import { createContext, useContext, useState, useEffect } from 'react'
import { appendPreservedParams } from '@/utils/urlUtils'

const QueryParamContext = createContext(undefined)

export const useQueryParams = () => {
  const context = useContext(QueryParamContext)
  if (!context) {
    throw new Error('useQueryParams must be used within a QueryParamProvider')
  }
  return context
}

// Captures the initial query parameters once and preserves them throughout
// the visit. It is SSR-safe because effects do not run on the server, and
// appendQueryParams avoids accessing window when no parameters are stored.

export const QueryParamProvider = ({ children }) => {
  const [initialQueryParams, setInitialQueryParams] = useState('')

  useEffect(() => {
    setInitialQueryParams(window.location.search)
  }, [])

  const appendQueryParams = url =>
    appendPreservedParams(url, initialQueryParams)

  return (
    <QueryParamContext.Provider
      value={{ initialQueryParams, appendQueryParams }}
    >
      {children}
    </QueryParamContext.Provider>
  )
}
